export const reasonsSchema = {
  telesales_not_found: "عدم یافتن تور مناسب",
  telesales_incident: "مشکلات فنی",
  telesales_complexities: "پیچیدگی رزرو آنلاین",
  telesales_help: "نیاز به راهنمایی کارشناس",
  telesales_complex_trip: "برنامه سفر پیچیده",
  telesales_do_not_trust: "عدم اعتماد به رزرو آنلاین",
  telesales_special_request: "درخواست‌های ویژه"
};
export const storageKey = "submit-telesales-reserve";

export const description =
  "بعد از ثبت درخواست، کارشناسان ما در اسرع وقت با شما تماس خواهند گرفت وشما را برای رزرو تور راهنمایی خواهند کرد.";
